var exports = {
  "IdeListItem": "IdeListItem__S7Sl-V",
  "IdeListItem--small": "IdeListItem--small__zW2jPL",
  "IdeListItem--medium": "IdeListItem--medium__Kys7Ys",
  "IdeListItem--big": "IdeListItem--big__r4KYP4",
  "IdeListItem__button": "IdeListItem__button__q5gYQ3",
  "IdeListItem__button-text": "IdeListItem__button-text__oN8hvt",
  "IdeListItem__subtext": "IdeListItem__subtext__9cMD6e",
};

__webpack_require__.r(module.exports = exports);
